const { getSignature } = require('core');
const {
    createDataUri,
    modalPresenter,
    setViewData
} = require('gui');

module.exports = function signaturePresenter(signature) {
    const view = require('./signaturePresenter.tpl.html');
    const signatureModalPresenter = modalPresenter();
    const c = {};
    const modalRegion = signatureModalPresenter.contentRegion();

    c.show = function(region) {
        view.activate(modalRegion);

        setViewData(view, signature);
        getSignature(signature.id).then(onResponse);
        view.image.addEventListener('load', signatureModalPresenter.center);

        signatureModalPresenter.show();
        signatureModalPresenter.subscribeClose(onClose);
    };

    function onResponse(response) {
        view.image.src = createDataUri(response.MimeType, response.SignatureContents);
    }

    function onClose() {
        view.image.removeEventListener('load', signatureModalPresenter.center);
        signatureModalPresenter.unsubscribeClose(onClose);
        view.deactivate();
    };

    return c;
};
